/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ReactInputs */

const en_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React`)
};

const ar_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React`)
};

const bn_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React`)
};

const de_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reagieren`)
};

const es_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaccionar`)
};

const fr_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réagir`)
};

const pt_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reagir`)
};

const zh_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反应`)
};

const tr_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tepki ver`)
};

const ru_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реакция`)
};

const pl_svchip_react = /** @type {(inputs: Svchip_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaguj`)
};

/**
* | output |
* | --- |
* | "React" |
*
* @param {Svchip_ReactInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_react = /** @type {((inputs?: Svchip_ReactInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ReactInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_react(inputs)
	if (locale === "bn") return bn_svchip_react(inputs)
	if (locale === "de") return de_svchip_react(inputs)
	if (locale === "es") return es_svchip_react(inputs)
	if (locale === "fr") return fr_svchip_react(inputs)
	if (locale === "pt") return pt_svchip_react(inputs)
	if (locale === "zh") return zh_svchip_react(inputs)
	if (locale === "tr") return tr_svchip_react(inputs)
	if (locale === "ru") return ru_svchip_react(inputs)
	if (locale === "pl") return pl_svchip_react(inputs)
	return en_svchip_react(inputs)
});